import { MediaType } from 'modules/media/interfaces/api';
// import { IContentItem } from 'modules/playlist/interfaces/api';
import { getYoutubeVideoId, isMp4Url, isYouTubeUrl } from 'utils/getYoutubeId';

interface IRenderMedia {
  url: string;
  type: MediaType;
  name: string;
}

export const RenderMedia = (item?: IRenderMedia, border?: number, autoPlay = false, controls = true) => {
  if (!item?.url) return null;

  const style: React.CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover',
    borderRadius: border ? `${border}px` : '1px',
  };

  if (item.type === MediaType.VIDEO) {
    if (isMp4Url(item.url)) {
      return <video src={item.url} style={style} autoPlay={autoPlay} controls={controls} />;
    }

    // fallback video
    return <video src={item.url} style={style} autoPlay={autoPlay} controls={controls} />;
  }

  if (item.type === MediaType.FILE) {
    if (isYouTubeUrl(item.url)) {
      const videoId = getYoutubeVideoId(item.url);
      if (!videoId) return null;

      return (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&loop=1&playlist=${videoId}`}
          style={style}
          allow='autoplay'
          allowFullScreen
          title={item.name}
        />
      );
    }

    if (isMp4Url(item.url)) {
      return <video src={item.url} style={style} controls={controls} autoPlay={autoPlay}/>;
    }

    return <img src={item.url} style={style} alt={item.name} draggable={false} />;
  }

  // IMAGE
  return <img src={item.url} style={style} alt={item.name} draggable={false} />;
};
